import React, { useEffect } from 'react'
import { Form, Input, message } from 'antd'
import { Modal } from '~/Components/Modal'
import { OrganizationsService } from '~/Services/OrganizationService'
import { useAppSelector } from '~/Store/hooks'
import { UserSelectors } from '~/Store/User'

interface AddCompanyModalProps {
  visible: boolean
  onClose: () => void
  onSuccess?: () => void
}

export const AddCompanyModal: React.FC<AddCompanyModalProps> = ({
  visible,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = React.useState(false)
  const currentUser = useAppSelector(UserSelectors.getCurrentUser)

  useEffect(() => {
    if (visible) {
      form.resetFields()
    }
  }, [visible, form])

  const handleSubmit = async (values: any) => {
    // Bước 1: Kiểm tra có user ID không
    if (!currentUser?.id) {
      message.error('Không lấy được thông tin user hiện tại!')
      return
    }

    try {
      setLoading(true)

      // Bước 2: Tạo organization với đầy đủ fields
      const response = await OrganizationsService.Post.createOrganization([
        {
          companyName: values.companyName,
          billingAddress: values.billingAddress,
          billingCity: values.billingCity,
          // billingAddress2: '',
          // billingState: '',
          // billingZip: '',
          // crmId: '',
          // duns: '',
          // naics: '',
        },
      ])

      // Lấy orgId từ response
      let newOrgId: string | undefined
      if (response && response.data) {
        if (Array.isArray(response.data) && response.data[0]?.guid) {
          newOrgId = response.data[0].guid
        } else if (response.data.guid) {
          newOrgId = response.data.guid
        }
      }

      if (!newOrgId) {
        message.error('Không lấy được ID công ty vừa tạo!')
        setLoading(false)
        return
      }

      await OrganizationsService.Post.addOrganizationUser(newOrgId, [
        currentUser.id,
      ])
      await OrganizationsService.Post.addOrganizationAdmin(
        newOrgId,
        currentUser.id,
      )

      message.success('Tạo công ty và thiết lập admin thành công!')
      form.resetFields()
      onClose()

      if (onSuccess) {
        onSuccess()
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || 'Tạo công ty thất bại!')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title="Thêm công ty mới"
      visible={visible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      width={500}
      okText="Tạo công ty"
      cancelText="Hủy"
      loadingData={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Tên công ty"
          name="companyName"
          rules={[{ required: true, message: 'Vui lòng nhập tên công ty!' }]}
        >
          <Input placeholder="Nhập tên công ty" />
        </Form.Item>

        <Form.Item
          label="Địa chỉ"
          name="billingAddress"
          rules={[{ required: true, message: 'Vui lòng nhập địa chỉ!' }]}
        >
          <Input placeholder="Nhập địa chỉ" />
        </Form.Item>

        <Form.Item
          label="Thành phố"
          name="billingCity"
          rules={[{ required: true, message: 'Vui lòng nhập thành phố!' }]}
        >
          <Input placeholder="Nhập thành phố" />
        </Form.Item>
      </Form>
    </Modal>
  )
}